import React, { useEffect, useState } from "react";
import userApi from "../../HTTP/user";

const RecommendToFriendPopup = ({ isOpen, onClose, onConfirm, title }) => {
  const [friends, setFriends] = useState([]);
  const [friendSearchTerm, setFriendSearchTerm] = useState("");
  const [selectedFriendId, setSelectedFriendId] = useState("");
  const [loadingFriends, setLoadingFriends] = useState(false);
  const [isSending, setIsSending] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    let isMounted = true;

    const loadFriends = async () => {
      try {
        setLoadingFriends(true);
        const friendsList = await userApi.getAllFriends();
        if (!isMounted) return;
        setFriends(Array.isArray(friendsList) ? friendsList : []);
      } catch (error) {
        console.error("Erreur lors du chargement des amis", error);
        if (isMounted) setFriends([]);
      } finally {
        if (isMounted) setLoadingFriends(false);
      }
    };

    setFriendSearchTerm("");
    setSelectedFriendId("");
    loadFriends();

    return () => {
      isMounted = false;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const normalizedSearchTerm = friendSearchTerm.trim().toLowerCase();
  const filteredFriends = friends.filter((friend) => {
    const fullName = `${friend.firstname || ""} ${friend.lastname || ""}`.trim().toLowerCase();
    return fullName.includes(normalizedSearchTerm);
  });

  const handleConfirm = async () => {
    if (!selectedFriendId || isSending) return;
    try {
      setIsSending(true);
      const sent = await onConfirm(Number(selectedFriendId));
      if (sent) {
        onClose();
      }
    } catch (error) {
      console.error("Erreur lors de l'envoi de la notification", error);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="w-full max-w-md rounded-lg bg-white p-4">
        <h3 className="mb-3 text-lg font-bold">{title}</h3>

        {loadingFriends ? (
          <p>Chargement des amis...</p>
        ) : (
          <>
            {friends.length === 0 ? (
              <p className="mb-4 text-gray-600">Aucun ami disponible.</p>
            ) : (
              <>
                <input
                  type="text"
                  value={friendSearchTerm}
                  onChange={(event) => {
                    setFriendSearchTerm(event.target.value);
                    setSelectedFriendId("");
                  }}
                  placeholder="Rechercher un ami..."
                  className="mb-3 w-full rounded border border-gray-300 p-2"
                />
                <select
                  value={selectedFriendId}
                  onChange={(event) => setSelectedFriendId(event.target.value)}
                  className="mb-4 w-full rounded border border-gray-300 p-2"
                >
                  <option value="">
                    {filteredFriends.length > 0 ? "Choisir un ami" : "Aucun ami trouve"}
                  </option>
                  {filteredFriends.map((friend) => (
                    <option key={friend.id} value={friend.id}>
                      {friend.firstname} {friend.lastname}
                    </option>
                  ))}
                </select>
              </>
            )}
          </>
        )}

        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="rounded bg-gray-200 px-4 py-2 text-black"
            disabled={isSending}
          >
            Annuler
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={isSending || !selectedFriendId || filteredFriends.length === 0}
            className={`rounded px-4 py-2 font-semibold ${
              isSending || !selectedFriendId || filteredFriends.length === 0
                ? "cursor-not-allowed bg-gray-300 text-gray-600"
                : "bg-validbutton text-black hover:bg-validbuttonhover"
            }`}
          >
            {isSending ? "Envoi..." : "Envoyer"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecommendToFriendPopup;
